<small class="debug"> {{ me }} </small>
<div [@loginState]="loginState" class="login-page" id="appLogin">
    <!--  [ngClass.xs]="'xs-login-page'" -->
    <div *ngIf="!m_mode" class="langTheme site-mode">
        <app-local-diag [setLargeMode]="true"></app-local-diag>
        <app-theme-selector></app-theme-selector>
    </div>
    <br/>
    <form autocomplete="off" class="form-signin" role="form">
        <div [ngSwitch]="m_currentViewMode">
            <div *ngSwitchCase="m_viewMod.INIT">
                <mat-icon>refresh</mat-icon>
                init mode
            </div>
            <div *ngSwitchCase="m_viewMod.LOGIN_IN_PROGRESS">
                <app-loading [@fadeIn] [type]="'ai'" [size]="'80px'" [style]="{'margin-top': '150px'}"></app-loading>
                <div class="text-center" style="margin-top: 20px;">
                    <span flashlightText style="font-size: 1.1em; font-weight: bold">Loading studio...</span>
                </div>
            </div>
            <div *ngSwitchCase="m_viewMod.LOGIN">
                <h2 class="form-signin-heading"></h2>
                <div class="homeLink">
                    <app-logo [overrideDefaultClass]="stylesObj" *ngIf="m_mode !== 'CHECKOUT'"></app-logo>
                    <br/>
                    <mat-label *ngIf="!isWhiteLabeled" class="textColorFive" style="font-size: 10px">{{ 'account.freeSignage' | transloco }}</mat-label>
                    <div [ngSwitch]="m_mode">
                        <div *ngSwitchCase="'CREATE_ACCOUNT'">
                            <mat-label class="textColorFive" style="font-size: 14px">
                                [ {{ 'general.createAccount2' | transloco }} ]
                            </mat-label>
                        </div>
                        <div *ngSwitchCase="'CHECKOUT'">
                            <mat-label class="textColorFive" style="font-size: 14px">
                                [ {{ 'general.readyForCheckout' | transloco }} ]
                            </mat-label>
                        </div>
                        <div *ngSwitchDefault>
                            <mat-label *ngIf="!isWhiteLabeled" class="textColorFive" style="font-size: 14px">
                                [ {{ 'general.amazed' | transloco }} ]
                            </mat-label>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
                <div>
                    <small class="debug"> {{ me }} </small>
                    <!--                    <div style="overflow: hidden">-->
                    <!--                        <iframe [src]="'https://www.cnn.com' | safeHTML" align="middle" style="border:none;overflow: hidden"></iframe>-->
                    <!--                    </div>-->
                    <mat-form-field [ngClass]="{disabledInput: disabledLoginInputs}">
                        <mat-label *ngIf="m_mode === 'CREATE_ACCOUNT'">{{ 'account.email' | transloco }}</mat-label>
                        <input #userLogin *ngIf="m_mode === 'CREATE_ACCOUNT'" inputrestriction="login" (invalidCharacter)="messageInvalidCharChosen($event)" (blur)="checkUsername()" [disabled]="disabledLoginInputs"
                               autocomplete="off" matInput (keyup.enter)="passFocus($event)" #userName spellcheck="false" type="text"
                               name="m_user" [(ngModel)]="m_user" placeholder="" required>

                        <mat-label *ngIf="m_mode !== 'CREATE_ACCOUNT'">{{ 'account.userEmail' | transloco }}</mat-label>
                        <input #userLogin *ngIf="m_mode !== 'CREATE_ACCOUNT'" inputrestriction="login" (invalidCharacter)="messageInvalidCharChosen($event)" (blur)="checkUsername()" [disabled]="disabledLoginInputs"
                               autocomplete="off" matInput (keyup.enter)="passFocus($event)" #userName spellcheck="false" type="text"
                               name="m_user" [(ngModel)]="m_user" placeholder="" required>
                    </mat-form-field>

                    <!-- main password -->
                    <mat-form-field [ngClass]="{disabledInput: disabledLoginInputs}">
                        <mat-label>{{ 'account.password' | transloco }}</mat-label>
                        <input *ngIf="m_mode === 'CREATE_ACCOUNT'" [opts]="'password'" inputrestriction="password" (invalidCharacter)="messageInvalidCharChosen($event)" [disabled]="disabledLoginInputs" autocomplete="off" matInput (keyup.enter)="passFocusSecondPass()"
                               #userPass type="password" [(ngModel)]="m_pass" name="m_pass"
                               placeholder="" required>

                        <input *ngIf="m_mode !== 'CREATE_ACCOUNT'" [opts]="'password'" inputrestriction="password" (invalidCharacter)="messageInvalidCharChosen($event)" [disabled]="disabledLoginInputs" autocomplete="off" matInput (keyup.enter)="signInWithEmail()"
                               #userPass type="password" [(ngModel)]="m_pass" name="m_pass"
                               placeholder="" required>
                    </mat-form-field>

                    <!-- repeat password -->
                    <mat-form-field *ngIf="m_mode === 'CREATE_ACCOUNT'" [ngClass]="{disabledInput: disabledLoginInputs}">
                        <mat-label>{{ 'account.repeatPass' | transloco }}</mat-label>
                        <input inputrestriction="password" [opts]="'password'" (invalidCharacter)="messageInvalidCharChosen($event)" [disabled]="disabledLoginInputs" autocomplete="off" matInput (keyup.enter)="createAccount($event)"
                               #userPass2 type="password" [(ngModel)]="m_passRepeat" name="m_passRepeat"
                               placeholder="" required>
                    </mat-form-field>
                </div>
                <br/>
                <br/>

                <div *ngIf="(privateServer?.length > 10  || ldapServer?.length > 10) === false">
                    <div *ngIf="!isWhiteLabeled" fxLayout="row" fxLayoutAlign="center center">
                        <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithEmail'}" class="loginCreateAccountText"
                           matTooltipPosition="above" matTooltip="{{'account.loginNow' | transloco}}"
                           (click)="onLoginWith('loginWithEmail',$event)" href="#">
                            <fa-icon size="1x" [icon]="faEnvelope"></fa-icon>
                        </a>
                        <!-- future support for Guest login... maybe -->
                        <!--  <a [ngClass]="{'selectedNav':selectedLoginMode === 'continueAsGuest'}" class="loginCreateAccountText" matTooltipPosition="above" matTooltip="{{'account.continueAsGuest' | transloco}}" (click)="onLoginWith('continueAsGuest',$event)" href="#">-->
                        <!--       <fa-icon [icon]="faUser"></fa-icon>-->
                        <!--  </a>-->
                        <!--                    <asl-google-signin-button type='icon' size='medium'></asl-google-signin-button>-->
                        <!--                    <asl-google-signin-button></asl-google-signin-button>-->
                        <!--                    <google-signin-butt></google-signin-butt>-->
                        <div [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithGL'}" class="loginCreateAccountText" matTooltipPosition="above" (click)="onLoginWith('loginWithGL',$event)" href="#">
                            <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                            <fa-icon size="1x" [icon]="faGoogle"></fa-icon>
                        </div>
                        <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithAmazon'}" class="loginCreateAccountText faAmazon"
                           matTooltipPosition="above" matTooltip="{{'account.loginWithAmazon' | transloco}}"
                           (click)="onLoginWith('loginWithAmazon',$event)" href="#">
                            <fa-icon class="fixAmazon" size="1x" [icon]="faAmazon"></fa-icon>
                        </a>
                        <!-- disabled for facebook now -->
                        <!--             <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithFB'}" class="loginCreateAccountText"-->
                        <!--                       matTooltipPosition="above" matTooltip="{{'account.loginWithFB' | transloco}}"-->
                        <!--                       (click)="onLoginWith('loginWithFB',$event)" href="#">-->
                        <!--                        <fa-icon [icon]="faFacebook"></fa-icon>-->
                        <!--                    </a>-->
                        <!--                    <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithPrivates'}" class="loginCreateAccountText" matTooltipPosition="above" matTooltip="{{'account.loginWithLdapPrivates' | transloco}}" (click)="onLoginWith('loginWithPrivates',$event)" href="#">-->
                        <!--                        <fa-icon [icon]="faServer"></fa-icon>-->
                        <!--             </a>-->
                    </div>
                </div>
                <br/>
                <ul class="loginButtons" [ngSwitch]="selectedLoginMode">
                    <div *ngSwitchCase="'loginWithEmail'">
                        <button *ngIf="m_mode === 'CREATE_ACCOUNT'" type="button" (click)="createAccount($event)" class="full-button" mat-stroked-button>
                            {{ 'account.continue' | transloco }}
                            <fa-icon [icon]="faSignInAlt"></fa-icon>
                        </button>
                        <button *ngIf="m_mode !== 'CREATE_ACCOUNT'" type="button" (click)="signInWithEmail()" class="full-button" mat-stroked-button>
                            <ng-container>
                                {{ 'account.loginNow' | transloco }}
                                <fa-icon [icon]="faSignInAlt"></fa-icon>
                            </ng-container>
                        </button>
                    </div>
                    <div *ngSwitchCase="'continueAsGuest'">
                        <button class="guestButton" type="button" (click)="signInGuest($event)" class="full-button" mat-stroked-button>
                            {{ 'account.continueAsGuest' | transloco }}
                            <fa-icon [icon]="faUser"></fa-icon>
                        </button>
                    </div>
                    <div *ngSwitchCase="'loginWithAmazon'">
                        <button *ngIf="m_mode === 'CREATE_ACCOUNT'" class="amazonButton full-button" type="button" (click)="onLoginAmazonPopup($event)" mat-stroked-button>
                            {{ 'account.createWithAmazon' | transloco }}
                            <fa-icon [icon]="faAmazon"></fa-icon>
                        </button>
                        <!--                        <a *ngIf="m_mode === 'CREATE_ACCOUNT'" (click)="backToLogin()" mat-button class="backToMain">-->
                        <!--                            <mat-icon>keyboard_arrow_left</mat-icon>-->
                        <!--                            {{'account.back' | transloco}}-->
                        <!--                        </a>-->
                        <button *ngIf="m_mode !== 'CREATE_ACCOUNT'" class="amazonButton full-button" type="button"
                                (click)="onLoginAmazonPopup($event)" mat-stroked-button>{{ 'account.loginWithAmazon' | transloco }}
                            <fa-icon [icon]="faAmazon"></fa-icon>
                        </button>
                    </div>
                    <div *ngSwitchCase="'loginWithGL'">
                        <!--                        <asl-google-signin-button type='icon' size='medium'></asl-google-signin-button>-->
                        <!--                        <asl-google-signin-button></asl-google-signin-button>-->
                        <!--                        <google-signin-butt></google-signin-butt>-->
                        <div *ngIf="m_mode === 'CREATE_ACCOUNT'" class="googleButton full-button" type="button" (click)="signInWithGoogle()">
                            <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                            <!--                            <fa-icon [icon]="faGoogle"></fa-icon>-->
                        </div>
                        <div *ngIf="m_mode !== 'CREATE_ACCOUNT'" class="googleButton full-button" type="button" (click)="signInWithGoogle()">
                            <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                            <!--                            <fa-icon [icon]="faGoogle"></fa-icon>-->
                        </div>
                    </div>
                    <div *ngSwitchCase="'loginWithFB'">
                        <button *ngIf="m_mode === 'CREATE_ACCOUNT'" class="facebookButton full-button" type="button" (click)="signInWithFB()"
                                mat-stroked-button>{{ 'account.createWithFB' | transloco }}
                            <fa-icon [icon]="faFacebook"></fa-icon>
                        </button>
                        <button *ngIf="m_mode !== 'CREATE_ACCOUNT'" class="facebookButton full-button" type="button" (click)="signInWithFB()"
                                mat-stroked-button>{{ 'account.loginWithFB' | transloco }}
                            <fa-icon [icon]="faFacebook"></fa-icon>
                        </button>
                    </div>

                    <!--                    <div *ngSwitchCase="'loginWithPrivates'" fxLayout="row">-->
                    <!--                        <button fxLayout *ngIf="m_mode === 'CREATE_ACCOUNT'" class="privatesButton privatesButtonMove" type="button" (click)="createWithPrivates()" mat-stroked-button>{{'account.createWithPrivates2' | transloco}}</button>-->
                    <!--                        <button fxLayout *ngIf="m_mode !== 'CREATE_ACCOUNT'" class="privatesButton privatesButtonMove" type="button" (click)="signInWithPrivates()" mat-stroked-button>{{'account.loginWithPrivates3' | transloco}}</button>-->
                    <!--                        <button fxLayout mat-flat-button class="privatesButtonSettings privatesButtonMove" (click)="setupWithPrivates()" matTooltip="{{'general.settings' | transloco}}">-->
                    <!--                            <mat-icon style="font-size: 1.4em; position: relative; left: -11px; top: 2px">build</mat-icon>-->
                    <!--                        </button>-->
                    <!--                    </div>-->

                    <div *ngIf="showCreateAccount">
                        <div *ngIf="m_mode !== 'CREATE_ACCOUNT'" style="padding-top: 12px">
                            {{ 'account.or' | transloco }}
                        </div>
                        <br/>
                        <button *ngIf="m_mode !== 'CREATE_ACCOUNT'" type="button" (click)="createNewAccount($event)" class="full-button" mat-stroked-button>
                            {{ 'account.createNewAccount2' | transloco }}
                            <fa-icon [icon]="faKey"></fa-icon>
                        </button>
                    </div>
                </ul>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <div *ngIf="!isWhiteLabeled; else showPassword" class="linkOptions">
                    <a *ngIf="m_mode !== 'CREATE_ACCOUNT'" class="loginCreateAccountText"
                       matTooltip="{{'account.options' | transloco}}" href="#" (click)="onShowOptions('settings',$event)">
                        <fa-icon [icon]="faCog"></fa-icon>
                    </a>
                    <a *ngIf="!isWhiteLabeled" class="loginCreateAccountText" matTooltip="{{'account.downloads' | transloco}}" href="#"
                       routerLink="/getstarted/downloads">
                        <fa-icon [icon]="faCloudDownloadAlt"></fa-icon>
                    </a>
                    <a *ngIf="!isWhiteLabeled" class="loginCreateAccountText" matTooltip="{{'account.cart' | transloco}}" href="#"
                       routerLink="/shopping-cart/list">
                        <fa-icon [icon]="faShoppingCart"></fa-icon>
                    </a>
                    <a *ngIf="!isWhiteLabeled" class="loginCreateAccountText" matTooltip="{{'account.products' | transloco}}" href="#"
                       routerLink="/shopping-cart/products">
                        <fa-icon [icon]="faTag"></fa-icon>
                    </a>
                    <a class="loginCreateAccountText" matTooltip="{{'account.homePage' | transloco}}" href="#"
                       (click)="onShowOptions('home',$event)">
                        <fa-icon [icon]="faHome"></fa-icon>
                    </a>
                    <a *ngIf="!isWhiteLabeled" class="loginCreateAccountText" matTooltip="{{'account.help' | transloco}}" href="#"
                       (click)="navigateToParam($event, '/shopping-cart/helpdesk?back=true')">
                        <fa-icon [icon]="faQuestionCircle"></fa-icon>
                    </a>
                </div>
                <ng-template #showPassword>
                    <a *ngIf="showCreateAccount" (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)" href="#">
                        {{ 'account.forgotPassword' | transloco }}
                    </a>
                </ng-template>
                <br/>
                @if (isWhiteLabeled && !showCreateAccount) {
                    <div>
                        <a id="forgotPassword" fxFlex fxLayoutAlign="center center" (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)" href="#">
                            <mat-icon>report</mat-icon>
                            <span style="margin-left: 5px;">{{ 'account.forgotPassword' | transloco }}</span>
                        </a>
                    </div>
                }
                <span class="privEnabled" *ngIf="privateServer && privateServer.length > 10">
                    <mat-icon>verified_user</mat-icon>
                    {{ 'account.privateEnabled' | transloco }}
                </span>
                <br/>
                <br/>
                <span class="privEnabled" style="position: relative; top: -10px; left: -3px"
                      *ngIf="ldapServer && ldapServer.length > 10">
                    <mat-icon>verified_user</mat-icon>
                    {{ 'account.ldapEnabled' | transloco }}
                </span>
                <br/>
                <div class="wrapSettings" *ngIf="selectedOptions === 'settings'">
                    <div class="rememberMe">
                        <label class="checkbox">
                            <input #rememberMe type="checkbox" [checked]="m_rememberMe" (change)="m_rememberMe = rememberMe.checked"/>
                            <span class="textColorFive">{{ 'account.rememberMe' | transloco }}</span>
                        </label>
                        <div id="loginExtras">
                            <a *ngIf="!isWhiteLabeled" id="forgotPassword" (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)" href="#">
                                <mat-icon>report</mat-icon>
                                {{ 'account.forgotPassword' | transloco }}</a>
                            <br *ngIf="!isWhiteLabeled"/>
                            <a id="changePassword" (click)="$event.preventDefault(); setViewMode(m_viewMod.CHANGE_PASSWORD)" href="#">
                                <mat-icon>vpn_key</mat-icon>
                                {{ 'account.changePassword' | transloco }}</a>
                            <br/>
                            <br/>
                            <a (click)="$event.preventDefault() ; setupWithPrivates()"
                               href="#">
                                <mat-icon>build</mat-icon>
                                {{ 'account.advancedLogin' | transloco }}</a>
                            <br/>
                            <!-- <a id="changeBusiness" (click)="$event.preventDefault(); setViewMode(m_viewMod.CHANGE_BUSINESS_NAME)" href="#">{{'account.businessName' | transloco}}</a> -->
                            <br/>
                            <a>
                                <mat-label class="version">{{ 'account.version' | transloco }}: {{ appVersion }}</mat-label>
                            </a>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
            </div>
            <br/>
            <div *ngSwitchCase="m_viewMod.CHANGE_PASSWORD">
                <app-change-password></app-change-password>
            </div>
            <div *ngSwitchCase="m_viewMod.FORGOT_PASSWORD">
                <app-forgot-password></app-forgot-password>
            </div>
            <div *ngSwitchCase="m_viewMod.CHANGE_BUSINESS_NAME">
                <app-business-rename></app-business-rename>
            </div>
            <div *ngSwitchDefault>
                <h1>something went wrong</h1>
                mode: {{ m_currentViewMode }}
            </div>
        </div>
    </form>
</div>


<ng-template let-modal #privatesModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">build</mat-icon>
        <span class="section-title">{{ 'placeholder.serverConnection' | transloco }}</span>
        <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <div fxLayout="column" fxLayoutAlign="center center" class="privatesModalWrap">
            <div fxFlex>
                <mat-checkbox [checked]="privateServer.length > 0"
                              (change)="onPrivatesCheckboxChanged('privateServer', $event.checked)">
                    <mat-icon>storage</mat-icon>
                    <mat-label>{{ 'account.privateSignage2' | transloco }}</mat-label>
                </mat-checkbox>
            </div>
            <div fxFlex>
                <mat-checkbox [checked]="ldapServer.length > 0"
                              (change)="onPrivatesCheckboxChanged('ldapServer', $event.checked)">
                    <mat-icon>storage</mat-icon>
                    <mat-label>LDAP {{ 'account.server' | transloco }}</mat-label>
                </mat-checkbox>
            </div>
        </div>
        <br/>
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-form-field [ngClass]="{disabledInput: privateServer.length === 0}" style="width: 80%" fxFlex>
                <input matInput
                       placeholder="{{'placeholder.privateServerDomain' | transloco}} (i.e.: https://master.example.com)"
                       (change)="onUpdatePrivatesStore('privateServer', $event.target['value'])"
                       [value]="privateServer" type="text" autocomplete="off"
                       [disabled]="privateServer.length === 0">
            </mat-form-field>
            <mat-form-field [ngClass]="{disabledInput: ldapServer.length === 0}" style="width: 80%" fxFlex>
                <input matInput
                       placeholder="{{'placeholder.privateLdapDomain' | transloco}} (i.e. server-address : domain-controller"
                       (change)="onUpdatePrivatesStore('ldapServer', $event.target['value'])"
                       [value]="ldapServer" type="text" autocomplete="off"
                       [disabled]="ldapServer.length === 0">
            </mat-form-field>
        </div>
    </div>
</ng-template>
